import PropTypes from 'prop-types';

export const categoryProps = {
  id: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  rank: PropTypes.number,
  subcategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      displayName: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

export const category = PropTypes.shape(categoryProps);
